import { MultiSelect as _MultiSelect } from "react-multi-select-component";

interface Props {
  options: { label: string; value: string }[];
  selected: { label: string; value: string }[];
  onChange: (selected: { label: string; value: string }[]) => void;
  placeholder?: string;
}

export const MultiSelect: React.FC<Props> = ({
  options,
  selected,
  onChange,
  placeholder = "Velg...",
}) => {
  return (
    <_MultiSelect
      options={options}
      value={selected}
      onChange={onChange}
      labelledBy="Select"
      hasSelectAll={false}
      disableSearch
      className="b3"
      overrideStrings={{
        selectSomeItems: placeholder,
        allItemsAreSelected: "Alle valgt",
        selectAll: "Velg alle",
        search: "Søk",
      }}
    />
  );
};
